import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { useLabelsMetadataStore } from '@aibees/elephant/store/labels-metadata';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

export function useAddLabelsGroupingMetadata(
  options: TableFilterSelectOption[]
) {
  // Use a selector to only re-render when metadata actually changes
  const metadata = useLabelsMetadataStore((state) => state.metadata);

  return useMemo(
    () =>
      options.map((o) => ({
        ...o,
        metadata:
          metadata &&
          (o.key !== LabelGrouping.ALL
            ? metadata[o.key as LabelGrouping]
            : metadata[LabelGrouping.COMPANY] + metadata[LabelGrouping.PEOPLE]),
      })),
    [metadata, options]
  );
}
